// extracted by mini-css-extract-plugin
export default {"left":"left-ese4Hr","right":"right-KH1H33","card":"card-qJPuUE","noRemind":"noRemind-sGGnM3","badge":"badge-v1lHsu","price":"price-RKYmRy"};